import React from "react";

const ServiceSessionBasedHover = () => {
  return (
    <>
      <svg
        width="120"
        height="129"
        viewBox="0 0 165 177"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_46692_101416)">
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H153C159.627 0 165 5.37258 165 12V165C165 171.627 159.627 177 153 177H12C5.37258 177 0 171.627 0 165V12Z"
            fill="white"
          />
          <path
            d="M17.7559 54.9531H38.9763M17.7559 65.9876H51.9685M121.476 54.9531H132.736"
            stroke="#044E97"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28.1494 86H136.201C141.831 86 146.378 90.5436 146.378 96.169V143.336C146.378 148.961 141.831 153.505 136.201 153.505H28.1494C22.5195 153.505 17.9723 148.961 17.9723 143.336V96.3854C17.7557 90.5436 22.303 86 28.1494 86Z"
            fill="#F8F8F8"
          />
          <path
            d="M121.477 65.9922H146.378"
            stroke="#044E97"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M30.5317 41.098C37.4679 41.098 43.0908 35.4796 43.0908 28.549C43.0908 21.6184 37.4679 16 30.5317 16C23.5955 16 17.9727 21.6184 17.9727 28.549C17.9727 35.4796 23.5955 41.098 30.5317 41.098Z"
            stroke="#044E97"
            stroke-miterlimit="10"
          />
          <path
            d="M124.076 23.5781V33.098H122.127V23.5781H124.076ZM134.469 23.5781V33.098H132.737L128.623 27.2563V33.098H126.674V23.5781H128.406L132.521 29.4199V23.5781H134.469ZM138.584 23.5781L140.966 30.7181L143.347 23.5781H145.513L142.265 33.098H139.666L136.418 23.5781H138.584Z"
            fill="#044E97"
          />
          <path
            d="M28.1496 86H136.201C141.831 86 146.378 90.5436 146.378 96.169V102.66H17.7559V96.169C17.7559 90.5436 22.3031 86 28.1496 86Z"
            fill="#F8F8F8"
          />
          <path
            d="M18.1888 102.011H146.161M18.1888 127.974H146.161M28.1494 86H136.201C141.831 86 146.378 90.5436 146.378 96.169V143.336C146.378 148.961 141.831 153.505 136.201 153.505H28.1494C22.5195 153.505 17.9723 148.961 17.9723 143.336V96.3854C17.7557 90.5436 22.303 86 28.1494 86Z"
            stroke="#BFC7D9"
            stroke-miterlimit="10"
          />
        </g>
        <rect
          x="0.5"
          y="0.5"
          width="164"
          height="176"
          rx="15.5"
          stroke="#044E97"
        />
        <defs>
          <clipPath id="clip0_46692_101416">
            <rect width="165" height="177" rx="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default ServiceSessionBasedHover;
